import React from 'react';

import { createClassName } from 'utils/createClassName';

import './authFormFooterLayoutStyles.css';

type Props = {
  axis?: 'x' | 'y';
  hasGap?: boolean;
};

export const AuthFormFooterLayoutComponent: React.FC<Props> = (props) => {
  const { children, axis = 'y', hasGap } = props;

  const createElementClassName = createClassName('authFormFooterLayout');

  return (
    <div className={createElementClassName('wrapper', { axis, hasGap })}>
      {children}
    </div>
  );
};
